export default __webpack_public_path__ + "img/bjldAqfu.820e8064.svg";